import axios from 'axios'
import api from "@/helpers/api";
import router from "@/router";
import store from "@/store";
import App from "@/App";
const state = {
    itemsTop: [],
    itemTopActive: '',
}

// getters
const getters = {
}

const actions = {
    getMenu(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/menus/',api.axiosConfig({type: 'top'})).then(response => {
                if(typeof response.data === 'object' && +response.data.error > 0) {
                    api.errorHandler(response.data.error);
                }
                context.commit('setMenu', response.data.result.top);
                resolve(response.data.result);
            }).catch(function (error) {
                resolve();
            });
        });
    },
}

const mutations = {
    setMenu(state, data) {
        if(typeof data === 'object' && data.items !== undefined) {
            state.itemsTop = data.items;
        }
    },
    setActionMenu(state, data){
        if(typeof data === 'object' && data.items !== undefined) {
            state.itemsAction = data.items;
        }
    },
    clearActivePath(state, data) {
        state.itemsTop = [];
        state.itemTopActive = '';
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
